export const CALLBACK_EXCHANGE_ERROR = {
  TOKEN_EXPIRED: 'token_expired',
  FLOW_COMPLETED: 'flow_completed',
  FLOW_CANCELLED: 'flow_cancelled',
  INVALID_TOKEN: 'invalid_token',
  NETWORK_ERROR: 'network_error',
};

const PUBLIC_ERROR_CODES = new Set([
  CALLBACK_EXCHANGE_ERROR.TOKEN_EXPIRED,
  CALLBACK_EXCHANGE_ERROR.FLOW_COMPLETED,
  CALLBACK_EXCHANGE_ERROR.FLOW_CANCELLED,
  CALLBACK_EXCHANGE_ERROR.INVALID_TOKEN,
]);

/**
 * Maps POST /self-service/exchange-callback-uid failures to MobileErrorPage types.
 */
export function getCallbackExchangeErrorType(error) {
  const status = error?.response?.status;
  const code = error?.response?.data?.error_code;

  if (PUBLIC_ERROR_CODES.has(code)) {
    return code;
  }

  if (!error?.response) {
    return CALLBACK_EXCHANGE_ERROR.NETWORK_ERROR;
  }

  if (status === 410) {
    return CALLBACK_EXCHANGE_ERROR.TOKEN_EXPIRED;
  }

  if (status >= 500) {
    return CALLBACK_EXCHANGE_ERROR.NETWORK_ERROR;
  }

  return CALLBACK_EXCHANGE_ERROR.INVALID_TOKEN;
}
